// Login form.
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import CheckBox from '../widgets/checkbox.jsx';
import VisiblePassword from '../widgets/visible-password.jsx';

const messages = defineMessages({
  operator_id: {
    id: 'operator_id_prompt',
    defaultMessage: 'Operator ID',
    description: 'Placeholder for operator login in the console theme'
  },
  access_key: {
    id: 'access_key_prompt',
    defaultMessage: 'Access Key',
    description: 'Placeholder for operator password in the console theme'
  }
});

export default class LoginView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      login: props.login,
      password: '',
      hostName: props.serverAddress,
      saveToken: props.persist
    };
    this.handleLoginChange = this.handleLoginChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleToggleSaveToken = this.handleToggleSaveToken.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleLoginChange(e) {
    this.setState({login: e.target.value});
  }

  handlePasswordChange(e) {
    this.setState({password: e.target.value});
  }

  handleToggleSaveToken() {
    this.props.onPersistenceChange(!this.state.saveToken);
    this.setState({saveToken: !this.state.saveToken});
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onLogin(this.state.login.trim(), this.state.password.trim());
  }

  render() {
    let submitClasses = 'primary';
    if (this.props.disabled) {
      submitClasses += ' disabled';
    }

    return (
      <form id="login-form" onSubmit={this.handleSubmit}>
        <div className="console-login-status">
          <div className="console-alert-indicator"><span /></div>
          <div>
            <h1>NETWORK OPERATIONS</h1>
            <p>Maintenance access gateway</p>
          </div>
        </div>
        <div className="console-status-card">
          <div><span className="status-dot warning" />Monitoring services: standby</div>
          <div><span className="status-dot danger" />External routes: restricted</div>
          <div><span className="status-dot success" />System integrity: verified</div>
        </div>
        <label className="console-field-label" htmlFor="inputLogin">OPERATOR ID</label>
        <FormattedMessage {...messages.operator_id}>
        {
          (operator_id) => <input type="text" id="inputLogin"
            placeholder={operator_id}
            autoComplete="username"
            autoCorrect="off"
            autoCapitalize="none"
            value={this.state.login}
            onChange={this.handleLoginChange}
            required autoFocus />
        }
        </FormattedMessage>
        <label className="console-field-label" htmlFor="inputPassword">ACCESS KEY</label>
        <FormattedMessage {...messages.access_key}>
        {
          (access_key) => <VisiblePassword type="password" id="inputPassword"
            placeholder={access_key}
            autoComplete="current-password"
            value={this.state.password}
            onChange={this.handlePasswordChange}
            required={true} />
        }
        </FormattedMessage>
        <div className="panel-form-row">
          <CheckBox id="save-token" name="save-token" checked={this.state.saveToken}
            onChange={this.handleToggleSaveToken} />
          <label htmlFor="save-token">&nbsp;
            Persist authorization
          </label>
          <a href="#reset">
            Recover key
          </a>
        </div>
        <div className="dialog-buttons">
          <button className={submitClasses} type="submit">
            Authorize Access
          </button>
        </div>
      </form>
    );
  }
};
